import { ICustomer } from '../models';
import { getIncludedResource } from '../util';
import * as application from './application';
import * as policy from './policy';
import * as moment from 'moment';

const dateFromApi = (date) => {
  if (! date) {
    return '';
  }

  const parsedDate = moment(date).format('DD/MM/YYYY');

  return parsedDate !== 'Invalid Date' ? parsedDate : '';
};

export function fromJsonApi(data: any, included: any[] = []): ICustomer {

  const channelName = 'BJP B2C';

  const policyApplications = getIncludedResource(data, included, 'quotes', true)
    .filter((item) => item.attributes.quote_type !== 'renewal'
      && item.attributes.quote_type !== 'temporary mta'
      && item.attributes.quote_type !== 'mid term adjustment' && item.attributes.status !== 'lapsed'
      && item.attributes.status !== 'referred' && item.attributes.channel_name === channelName)
    .map((item) => application.fromJsonApi(item, included));

  const policies = getIncludedResource(data, included, 'policies', true)
    .filter((item) => item.attributes.temporary_mta_policy_number === null)
    .map((item) => policy.fromJsonApi(item, included));

  const renewals = getIncludedResource(data, included, 'quotes', true)
    .filter((item) => item.attributes.quote_type === 'renewal' &&
      (item.attributes.status === 'renewal invited' || item.attributes.status === 'referral approved')
      && item.attributes.channel_name === channelName)
    .map((item) => application.fromJsonApi(item, included));

  return {
    id: data.id,
    title: data.attributes.title,
    firstName: data.attributes.first_name,
    lastName: data.attributes.last_name,
    customerName: data.attributes.customer_name,
    companyName: data.attributes.company_name,
    dob: dateFromApi(data.attributes.dob),
    address: data.attributes.address,
    email: data.attributes.email,
    phone1: data.attributes.phone1,
    phone2: data.attributes.phone2,
    status: data.attributes.status,
    deceased: data.attributes.deceased,
    metadata: {
      status: data.attributes.metadata.status,
      microEnterprise: data.attributes.metadata.micro_enterprise,
      tradingName: data.attributes.metadata.trading_name,
      companyRegistrationNumber: data.attributes.metadata.company_registration_number,
      year: data.attributes.metadata.year,
    },
    policyApplications,
    policies,
    renewals,
  };
}

export function toJsonApi(customer: ICustomer) {
  const attributes: any = {
    first_name: customer.firstName,
    last_name: customer.lastName,
    address: customer.address,
    email: customer.email,
    email_confirmataion: customer.emailConfirmation,
    company_name: customer.companyName,
    phone1: customer.phone1,
    phone2: customer.phone2,
    password: customer.password,
    password_confirmation: customer.passwordConfirmation,
  };

  const data: any = {
    type: 'customer',
    attributes,
    relationships: {},
  };

  return data;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/customer.ts